import qs from 'qs';
import { pick, pickBy } from 'lodash';

export const setQueryStringValue = (key, tab, history, location, setActiveValue) => {
  const queryString = qs.parse(location.search.slice(1));
  const pickDateFilers = pick(queryString, ['period_code', 'date_from', 'date_to', 'page_size']);
  queryString[tab] = key;

  if (key === -1) {
    setActiveValue(-1);
    location.search = qs.stringify(pickBy(pickDateFilers));
    return history.push(`${location.pathname}?${location.search}`);
  }

  if (queryString.page) {
    delete queryString.page;
  }

  setActiveValue(key);
  history.push(`${location.pathname}?${(location.search = qs.stringify(queryString))}`);
};
